<template>

  <b-overlay :show="loading">
    <b-row>

      <b-col cols="12">
        <b-card 
          class="mt-2"
          header="Общая статистика звонков"
        >
          <b-card-text>
            <ShortStats :stats="stats" />
          </b-card-text>
        </b-card>
      </b-col>

      <b-col sm="6">
        <b-card no-body class="mt-3" v-if="stats" header="Входящие">
          <b-card-text>
            <pie-chart
              :height="null"
              :width="null"
              :chartData="chartDataAll"/>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col sm="6">
        <b-card no-body class="mt-3" v-if="stats" header="Исходящие">
          <b-card-text>
            <pie-chart
              :height="null"
              :width="null"
              :chartData="chartDataIncoming"/>
          </b-card-text>
        </b-card>
      </b-col>

    </b-row>
  </b-overlay>
  
</template>

<script>
import Api from '@/lib/Api';
import Utils from '@/lib/Utils';
import { store } from '@/store';
import ShortStats from '@/components/ShortStats';
import PieChart from '@/components/PieChart';


export default {
    name: 'StatisticsOverview',
    components: {
        PieChart,
        ShortStats
    },
    props: [
        'projectId',
    ],
    data () {
        return {
            appState: store.state,
            loading: false,
            stats: {},
        }
    },
    created () {
        this.loadData();
    },
    watch: {
        '$route': 'loadData'
    },
    computed: {
        project () {
            return store.findProject(parseInt(this.projectId))
        },
        chartDataAll () {
            if (!this.stats) {
                return null;
            }
            return {
                labels: ['Входящие', 'Исходящие'],
                datasets: [{
                    data: [this.stats.incoming, this.stats.outgoing],
                    backgroundColor: ['#17a2b8', '#007bff']
                }]
            };
        },
        chartDataIncoming () {
            if (!this.stats) {
                return null;
            }
            return {
                labels: ['Другие номера', 'Call-tracking'],
                datasets: [{
                    data: [this.stats.calls, this.stats.tracking_calls],
                    backgroundColor: ['red', 'blue']
                }]
            };
        }
    },
    methods: {
        async loadData () {
            this.loading = true;
            try {
                const stats = await Api.getShortStats(parseInt(this.projectId));
                this.stats = stats;
            } catch (e) {
                console.error(e);
                this.$bvToast.toast('Ошибка загрузки статистики', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    noAutoHide: true
                });
            }
            this.loading = false;
        },
        formatRate (num) {
            return Math.round(num * 100) / 100;
        },
        ...Utils
    }
};

</script>
